import { 
    RequestActionTypes,
    FetchRequestStart,
    FetchRequestSuccess,
    FetchRequestSuccessPayload,
    FetchRequestFailure,
    FetchRequestFailurePayload,
    FetchRequestStartPayload,
} from "./request.types";

export const fetchRequestStart = (
    payload: FetchRequestStartPayload
):  FetchRequestStart => ({
    type: RequestActionTypes.FETCH_REQUEST_START,
    payload,
});

export const fetchRequestSuccess = (
    payload: FetchRequestSuccessPayload    
): FetchRequestSuccess => ({
    type: RequestActionTypes.FETCH_REQUEST_SUCCESS,
    payload,
});

export const fetchRequestFailure = (
    payload: FetchRequestFailurePayload
): FetchRequestFailure => ({
    type: RequestActionTypes.FETCH_REQUEST_FAILURE,
    payload,
});
